import React, { forwardRef, useRef } from 'react';
import Modal from '../../../../../core/components/Modal';
import styles from './ModalIndicador.module.scss';
import { Button } from 'primereact/button';
import { assignRefs } from '../../../../../core/utils/Global';
import MultipageIndicador from '../MultipageIndicador';

function ModalIndicador(props, ref) {
    const modalRef = useRef(null);
    const ModalBody = ({ modalData }) => (
        <>
            <MultipageIndicador idProposta={modalData?.id} isView disableButtonVoltar />
            <div className="buttonsRight">
                <Button
                    label="Voltar"
                    className="p-button-secondary"
                    type="button"
                    icon="pi pi-arrow-left"
                    onClick={() => modalRef.current?.hide()}
                />
            </div>
        </>
    );

    return (
        <Modal
            header={
                <>
                    <i className={`pi pi-file ${styles.iconHeader}`} />
                    Indicador
                </>
            }
            style={{ maxWidth: '90vw' }}
            widthOnMobile={700}
            onMobile={(styles) => ({ ...styles, maxWidth: '100vw', height: '100%' })}
            ref={assignRefs(ref, modalRef)}
            {...props}
        >
            <ModalBody />
        </Modal>
    );
}

export default forwardRef(ModalIndicador);
